import type { NavigationCounts } from '@risksmart-app/trpc/src/types';
import type {
  GetAppetiteCountQuery,
  Risk_Bool_Exp,
} from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetAppetiteCountDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { COUNT_STALE_TIME_MS, createQueryHook } from 'src/utils';

import type { NavigationCountArgs } from '../navigation/navigationCounts';
import {
  navigationCountsQueryOptions,
  toAggregate,
} from '../navigation/navigationCounts';

type AppetiteCountArgs = NavigationCountArgs & {
  // The equivalent Hasura bool_exp (over the risk table, incl. the
  // appetites>=1 predicate) — drives the GraphQL fallback so the flag-gated
  // twin counts identically. Built by useEntityWhereFilter.
  where?: Risk_Bool_Exp;
};

// The appetite badge counts the risk table (risks with >=1 appetite), so the
// tRPC procedure lives on the risk router (frontend.risk.appetiteCount) and
// the response maps to risk_aggregate.
export const useGetAppetiteCount = createQueryHook<
  AppetiteCountArgs,
  NavigationCounts,
  GetAppetiteCountQuery
>({
  trpcQueryOptions: navigationCountsQueryOptions,
  mapTrpcDataToGraphQL: (data) => ({
    risk_aggregate: { aggregate: toAggregate(data.appetite) },
  }),
  // Aggregate over a register; mutations invalidate it. See COI-882.
  trpcStaleTime: COUNT_STALE_TIME_MS,
  graphqlDocument: GetAppetiteCountDocument,
  graphqlVariables: (queryArgs) => ({ where: queryArgs?.where }),
});
